import { NavLink } from 'react-router-dom';
import { Zap, History, Bell, ArrowLeftRight, ChartColumn } from 'lucide-react';
import logo from '../assets/spinning-cat-logo.png';
import './Navbar.css';

const NAV_ITEMS = [
  { to: '/dashboard', label: 'Dashboard', Icon: Zap           },
  { to: '/history',   label: 'History',   Icon: History        },
  { to: '/alerts',    label: 'Alerts',    Icon: Bell           },
  { to: '/compare',   label: 'Compare',   Icon: ArrowLeftRight },
  { to: '/report',    label: 'Report',    Icon: ChartColumn    },
];

function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <img src={logo} alt="SpinningCat" style={{ width: '170px', display: 'block' }} />
        <div style={{ fontSize: '9px', color: 'var(--accent)', letterSpacing: '3px', marginTop: '4px' }}>SIGNAL</div>
      </div>

      <div className="navbar-status">
        <span className="status-dot live" />
        <span className="status-label">Live</span>
      </div>

      <ul className="navbar-links">
        {NAV_ITEMS.map(({ to, label, Icon }) => (
          <li key={to}>
            <NavLink
              to={to}
              className={({ isActive }) =>
                `nav-link${isActive ? ' nav-link--active' : ''}`
              }
            >
              <Icon size={16} className="nav-icon" aria-hidden="true" />
              <span>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>

      <div className="navbar-footer">
        <span className="navbar-version">v1.0</span>
      </div>
    </nav>
  );
}

export default Navbar;
